<template>
  <main>
    <section class="hero tw-relative">
      <header class="tw-w-full tw-flex tw-items-center tw-justify-center tw-text-center tw-bg-white">
        <img src="~@/assets/img/logo-header.svg" alt="Wall Street English" class="tw-pointer-events-none tw-outline-none">
      </header>
      <div class="lg:tw-container lg:tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-flex-row lg:tw-justify-between lg:tw-items-start lg:tw-gap-3">
        <div class="content-container">
          <div class="main-copy tw-hidden lg:tw-block">
            <h1>
              Queres aprender inglês?
            </h1>
            <ul class="perks-list tw-hidden lg:tw-block">
              <li>
                <svg id="Group_2368" data-name="Group 2368" xmlns="http://www.w3.org/2000/svg" width="33.611" height="32.882" viewBox="0 0 33.611 32.882">
                  <ellipse id="Ellipse_32" data-name="Ellipse 32" cx="15.664" cy="15.664" rx="15.664" ry="15.664" transform="translate(0 1.554)" fill="#fff"/>
                  <g id="_7-Check" data-name="7-Check" transform="translate(5.503 0)">
                    <path id="Path_5820" data-name="Path 5820" d="M34.948,50.27a2.93,2.93,0,0,0-2.265,4.779l7.442,9.117a2.659,2.659,0,0,0,2.223.987,2.852,2.852,0,0,0,2.239-1.326l15.459-24.9.008-.012a.8.8,0,0,0-.2-.941.821.821,0,0,0-1.194.083l-.017.02L43.052,55.693a.676.676,0,0,1-.961.052l-5.174-4.709a2.917,2.917,0,0,0-1.969-.767Z" transform="translate(-32.027 -37.756)" fill="#28c382"/>
                  </g>
                </svg>
                <span>AULAS PRESENCIAIS OU ONLINE</span>
              </li>
              <li>
                <svg id="Group_2368" data-name="Group 2368" xmlns="http://www.w3.org/2000/svg" width="33.611" height="32.882" viewBox="0 0 33.611 32.882">
                  <ellipse id="Ellipse_32" data-name="Ellipse 32" cx="15.664" cy="15.664" rx="15.664" ry="15.664" transform="translate(0 1.554)" fill="#fff"/>
                  <g id="_7-Check" data-name="7-Check" transform="translate(5.503 0)">
                    <path id="Path_5820" data-name="Path 5820" d="M34.948,50.27a2.93,2.93,0,0,0-2.265,4.779l7.442,9.117a2.659,2.659,0,0,0,2.223.987,2.852,2.852,0,0,0,2.239-1.326l15.459-24.9.008-.012a.8.8,0,0,0-.2-.941.821.821,0,0,0-1.194.083l-.017.02L43.052,55.693a.676.676,0,0,1-.961.052l-5.174-4.709a2.917,2.917,0,0,0-1.969-.767Z" transform="translate(-32.027 -37.756)" fill="#28c382"/>
                  </g>
                </svg>
                <span>PLATAFORMA INTERACTIVA 24H</span>
              </li>
              <li>
                <svg id="Group_2368" data-name="Group 2368" xmlns="http://www.w3.org/2000/svg" width="33.611" height="32.882" viewBox="0 0 33.611 32.882">
                  <ellipse id="Ellipse_32" data-name="Ellipse 32" cx="15.664" cy="15.664" rx="15.664" ry="15.664" transform="translate(0 1.554)" fill="#fff"/>
                  <g id="_7-Check" data-name="7-Check" transform="translate(5.503 0)">
                    <path id="Path_5820" data-name="Path 5820" d="M34.948,50.27a2.93,2.93,0,0,0-2.265,4.779l7.442,9.117a2.659,2.659,0,0,0,2.223.987,2.852,2.852,0,0,0,2.239-1.326l15.459-24.9.008-.012a.8.8,0,0,0-.2-.941.821.821,0,0,0-1.194.083l-.017.02L43.052,55.693a.676.676,0,0,1-.961.052l-5.174-4.709a2.917,2.917,0,0,0-1.969-.767Z" transform="translate(-32.027 -37.756)" fill="#28c382"/>
                  </g>
                </svg>
                <span>MANUAIS DIGITAIS E CENTENAS DE<br class="lg:tw-hidden">
                                    EXERCÍCIOS</span>
              </li>
            </ul>
            <img src="~@/assets/img/hero2025.svg">
          </div>
          <!-- COUNTDOWN -->
          <!-- <div class="vectors">
              <div class="countdown-container">
                  <h5>Tempo limitado</h5>
                  <div class="counter">
                      <div>
                          {{ hours }}
                      </div>
                      <div>
                          {{ minutes }}
                      </div>
                      <div class="seconds">
                          {{ seconds }}
                      </div>
                  </div>
              </div>
          </div> -->
        </div>
        <div>
          <div class="offer">Oferta Por tempo Limitado</div>
          <div class="form-container tw-relative">
            <Form v-if="!$store.state.formSuccess" />
            <FormSuccess v-if="$store.state.formSuccess" />
          </div>
        </div>
      </div>
    </section>
    <section class="reasons lg:tw-hidden">
      <div class="tw-container tw-relative">
        <ul class="perks-list">
          <li>
            <svg id="Group_2368" data-name="Group 2368" xmlns="http://www.w3.org/2000/svg" width="33.611" height="32.882" viewBox="0 0 33.611 32.882">
              <ellipse id="Ellipse_32" data-name="Ellipse 32" cx="15.664" cy="15.664" rx="15.664" ry="15.664" transform="translate(0 1.554)" fill="#fff"/>
              <g id="_7-Check" data-name="7-Check" transform="translate(5.503 0)">
                <path id="Path_5820" data-name="Path 5820" d="M34.948,50.27a2.93,2.93,0,0,0-2.265,4.779l7.442,9.117a2.659,2.659,0,0,0,2.223.987,2.852,2.852,0,0,0,2.239-1.326l15.459-24.9.008-.012a.8.8,0,0,0-.2-.941.821.821,0,0,0-1.194.083l-.017.02L43.052,55.693a.676.676,0,0,1-.961.052l-5.174-4.709a2.917,2.917,0,0,0-1.969-.767Z" transform="translate(-32.027 -37.756)" fill="#28c382"/>
              </g>
            </svg>
            <span>AULAS PRESENCIAIS OU ONLINE</span>
          </li>
          <li>
            <svg id="Group_2368" data-name="Group 2368" xmlns="http://www.w3.org/2000/svg" width="33.611" height="32.882" viewBox="0 0 33.611 32.882">
              <ellipse id="Ellipse_32" data-name="Ellipse 32" cx="15.664" cy="15.664" rx="15.664" ry="15.664" transform="translate(0 1.554)" fill="#fff"/>
              <g id="_7-Check" data-name="7-Check" transform="translate(5.503 0)">
                <path id="Path_5820" data-name="Path 5820" d="M34.948,50.27a2.93,2.93,0,0,0-2.265,4.779l7.442,9.117a2.659,2.659,0,0,0,2.223.987,2.852,2.852,0,0,0,2.239-1.326l15.459-24.9.008-.012a.8.8,0,0,0-.2-.941.821.821,0,0,0-1.194.083l-.017.02L43.052,55.693a.676.676,0,0,1-.961.052l-5.174-4.709a2.917,2.917,0,0,0-1.969-.767Z" transform="translate(-32.027 -37.756)" fill="#28c382"/>
              </g>
            </svg>
            <span>PLATAFORMA INTERACTIVA 24H</span>
          </li>
          <li>
            <svg id="Group_2368" data-name="Group 2368" xmlns="http://www.w3.org/2000/svg" width="33.611" height="32.882" viewBox="0 0 33.611 32.882">
              <ellipse id="Ellipse_32" data-name="Ellipse 32" cx="15.664" cy="15.664" rx="15.664" ry="15.664" transform="translate(0 1.554)" fill="#fff"/>
              <g id="_7-Check" data-name="7-Check" transform="translate(5.503 0)">
                <path id="Path_5820" data-name="Path 5820" d="M34.948,50.27a2.93,2.93,0,0,0-2.265,4.779l7.442,9.117a2.659,2.659,0,0,0,2.223.987,2.852,2.852,0,0,0,2.239-1.326l15.459-24.9.008-.012a.8.8,0,0,0-.2-.941.821.821,0,0,0-1.194.083l-.017.02L43.052,55.693a.676.676,0,0,1-.961.052l-5.174-4.709a2.917,2.917,0,0,0-1.969-.767Z" transform="translate(-32.027 -37.756)" fill="#28c382"/>
              </g>
            </svg>
            <span>MANUAIS DIGITAIS E CENTENAS DE<br class="lg:tw-hidden">
                            EXERCÍCIOS</span>
          </li>
        </ul>
        <img src="~@/assets/img/hero2025.svg">
      </div>
    </section>
    <section class="info">
      <div class="tw-container">
        <h3>15 dias de aulas <span>grátis</span></h3>
        <h4>sem compromisso</h4>
        <button class="btn-cta" v-scroll-to="'.form-container'">Aproveitar Oferta</button>
        <!-- <div class="form-container">
            <FormSecond v-if="!$store.state.formSuccess" />
            <FormSecondSuccess v-if="$store.state.formSuccess" />
        </div> -->
      </div>
    </section>
  </main>
</template>

<script>
import moment from 'moment';
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';
// import FormSecond from '@/components/FormSecond.vue';
// import FormSecondSuccess from '@/components/FormSecondSuccess.vue';

export default {
  name: 'Home',
  components: {
    Form,
    // FormSecond,
    FormSuccess,
    // FormSecondSuccess,
  },
  data() {

    return {
      // Countdown
      hours: undefined,
      minutes: undefined,
      seconds: undefined,
    };
  },
  mounted() {
    // this.countdown();
  },
  methods: {
    animatedSvgs() {
      document.getElementById('animated-line').src = document.getElementById('animated-line').src + '?' + (new Date()).getTime();
      document.getElementById('animated-svg').src = document.getElementById('animated-svg').src + '?' + (new Date()).getTime();
    },
    countdown() {

      // In every second, do:
      window.counter = setInterval(() => {

        const now = moment(),
            targetDate = moment().endOf('day'),
            diff = moment.duration(targetDate.diff(now));

        // Get times
        let hours = diff.hours(),
            minutes = diff.minutes(),
            seconds = diff.seconds();

        this.hours = hours.toLocaleString(undefined, {minimumIntegerDigits: 2});
        this.minutes = minutes.toLocaleString(undefined, {minimumIntegerDigits: 2});
        this.seconds = seconds.toLocaleString(undefined, {minimumIntegerDigits: 2});
      }, 1000);
    },
  },
};
</script>
